export enum StoryEventType {
	FINISH_STORY = 'finish_story',
	VIEW_CARD = 'view_card',
	VIEW_STORY = 'view_story',
	START_STORY = 'start_story',
	STORY_SHARE = 'story.share',
	REGISTER = 'register',
}
